export const getMediaType = mimeType => {
  return mimeType.split('/')[0]
}

export const getExtension = mimeType => {
  return mimeType.split('/')[1]
}
